import { getBrandSuccess } from "assets/js/data/branding/actions";
import CakeStore from "assets/js/store";
import fetchRoute from "utils/routes";
import {
	TaskBarHandler,
	Button,
	Icons,
	DialogHandler,
} from "cakemail-ui-components/lib/react";
import React from "react";
import { Translate, I18n } from "react-redux-i18n";
import BRAND from "assets/js/scenes/brand/const";
import { setBrandHeadElements } from "assets/js/BrandWrapper";
import { setBrandPreview } from "assets/js/actions";
import { isPartner } from "utils/apiUtils";
import { setUserBrand } from "assets/js/data/userBranding/actions";
import {
	addLegacyParameter, getSDKLink, isValidUrl,
	removeLegacyParameterByName, setBackToFlow,
} from "utils/urlUtils";
import {
	SEGMENT_EVENTS,
	trackSegmentEvent,
} from "assets/js/const/SegmentEvents";
import {
	setPublicUserBrand,
	setPublicUserBrandRepo,
	setPublicUserBrandReset,
} from "assets/js/data/publicFacingBranding/actions";
import { checkBrandRepo } from "utils/dataUtils";

/*
	findDataInBrand will find and return either the parent object by reference or the final path object
 */
export function findDataInBrand(path, stateSchema = {}, returnSchema = false) {
	let fullPath = path.split(".");
	if (!stateSchema) {
		stateSchema = {};
	}

	for (let i = 0; i < fullPath.length - 1; i++) {
		let elem = fullPath[i];
		if (!stateSchema?.[elem]) stateSchema[elem] = {};
		stateSchema = stateSchema[elem];
	}

	if (returnSchema) {
		return stateSchema;
	}
	return stateSchema[fullPath[fullPath.length - 1]];
}

/*
save actual brand to localstorage for when we close the preview
load back the back if possible, if not, refresh the page on the brand page.

Apply local brand to current brand
go through all css theme and apply them to root
 */
export function applyLocalBrandToPreview(
	brand,
	modifiedBrand,
	unpublishedBrand,
	history,
	info = {},
	previewCallback = () => {},
	previewUrl = "",
	historyState = undefined,
	brandRepo = null
) {
	/*
	TODO to make it modular, the publish / preview will need a callback from the main container
		And use this function.
	*/
	const accountId = CakeStore.getState().global.account.id;
	window.localStorage.setItem(
		accountId + "_" + BRAND.CURRENT_BRAND,
		JSON.stringify(brand)
	);
	window.localStorage.setItem(
		accountId + "_" + BRAND.MODIFIED_BRAND,
		JSON.stringify(modifiedBrand)
	);
	window.localStorage.setItem(
		accountId + "_" + BRAND.UNPUBLISHED_CHANGES,
		JSON.stringify(unpublishedBrand)
	);

	const modifiedBrandWithReplaceRef = brandRepo ? replaceReferences(modifiedBrand, brandRepo): modifiedBrand;

	if (isPartner()) {
		setBrandHeadElements(modifiedBrandWithReplaceRef);
		CakeStore.dispatch(getBrandSuccess(modifiedBrandWithReplaceRef));
	} else {
		CakeStore.dispatch(setUserBrand(modifiedBrandWithReplaceRef));
	}

	CakeStore.dispatch(setPublicUserBrand(modifiedBrandWithReplaceRef));
	CakeStore.dispatch(setPublicUserBrandRepo(CakeStore.getState().userBrandSDK));

	setStylesFromBrand(brandRepo ? replaceReferences(modifiedBrand, brandRepo, false): modifiedBrand);

	previewCallback(true);

	TaskBarHandler.show({
		tasks: [
			{
				className: "brandTaskBar",
				content: (
					<div>
						<div>
							<Icons name="glyph-show" />
							<p>
								<Translate
									value="app-brand-preview-bar-unpublished"
									count={info.count}
								/>
							</p>
						</div>

						<Button
							text={
								<Translate value="app-campaigns-template-preview_closeBtn" />
							}
							colorTheme="grey"
							shapeStyle="fill"
							radius="square"
							size="small"
							onClick={() => {
								CakeStore.dispatch(setPublicUserBrandReset());
								trackSegmentEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
									context: "Brand Preview Close",
								});
								removeLegacyParameterByName("brandPreview");
								history.push({
									pathname: fetchRoute("brand"),
									state: historyState,
								});
								previewCallback(false);
								TaskBarHandler.hide();
							}}
						/>
					</div>
				),
			},
		],
	});

	addLegacyParameter("brandPreview", "true");
	history.push(previewUrl ? previewUrl : fetchRoute("dashboard"));
}

export function setStylesFromBrand(modifiedBrand) {
	let userBrandSDK = CakeStore.getState().userBrandSDK;
	const prefix = "--";

	function appRecursive(themeObj) {
		for (const k in themeObj) {
			if (typeof themeObj[k] === "object" && themeObj[k] !== null) {
				appRecursive(themeObj[k]);
			} else {
				document.documentElement.style.setProperty(prefix + k, themeObj[k]);
			}
		}
	}

	appRecursive(modifiedBrand?.theme);

	const ignoredLeys = [
		"client_config",
		"page_customization",
		"images",
		"url",
		"themes",
	];
	const flatSDKObj = {};
	userBrandSDK?.colors?.forEach((color) => {
		flatSDKObj[color.id] = color.value;
	});

	function userStyleRecursive(obj, parentKeys = []) {
		for (const k in obj) {
			if (!ignoredLeys.includes(k)) {
				if (typeof obj[k] === "object" && obj[k] !== null) {
					userStyleRecursive(obj[k], [...parentKeys, k]);
				} else if (parentKeys[parentKeys.length - 1] === "styles") {
					//Any dynamic css should have a parent attributed to a resource then style property inside
					//ex : {list_redirection : {styles : {a : "b"}}}
					//Look for styles key to build object
					//build prefix with resource name to prevent key duplication
					const finalPrefix =
						prefix + parentKeys[parentKeys.length - 2].replace("_", "-") + "-";
					if (obj?.[k]?.indexOf("ref-") === 0) {
						document.documentElement.style.setProperty(
							finalPrefix + k,
							flatSDKObj[obj[k].split("-")[1]]
						);
					} else {
						document.documentElement.style.setProperty(finalPrefix + k, obj[k]);
					}
				}
			}
		}
	}

	userStyleRecursive(modifiedBrand);
}

export function showResetDialog(title, desc, callback = () => {}) {
	DialogHandler.show({
		title: title,
		content: <p>{desc}</p>,
		primaryBtnText: <Translate value="app-general-restore-default" />,
		primaryBtnOnClick: callback,
		secondaryBtnText: <Translate value="app-general-cancel" />,
	});
}

export function removeLocalBrandStorage() {
	const accountId = CakeStore.getState().global.account.id;

	window.localStorage.removeItem(accountId + "_" + BRAND.CURRENT_BRAND);
	window.localStorage.removeItem(accountId + "_" + BRAND.MODIFIED_BRAND);
	window.localStorage.removeItem(accountId + "_" + BRAND.UNPUBLISHED_CHANGES);
}

export function kebabToCamel(str) {
	return str.replace(/-([a-z])/g, (match) => {
		return match[1].toUpperCase();
	});
}

/**
 * Recursively replaces "ref-" references to BrandSDK
 *
 * @param obj
 * @param brandSDK
 * @returns
 */
export function replaceReferences(obj, brandSDK, doKebabToCamel = true) {

	// type object - recursivity happens here
	if (typeof obj === "object") {
		const outObject = {};

		for (const key in obj) {
			const newKey = doKebabToCamel ? kebabToCamel(key) : key

			if (Array.isArray(obj[key])) {
				outObject[newKey] = obj[key];
			} else if (obj[key]) {
				outObject[newKey] = replaceReferences(obj[key], brandSDK, doKebabToCamel);

				// special case - id becomes url (and is resolved)
				if (key === "id") {
					const value = resolveReference(brandSDK, obj[key], obj.type);
					if (isValidUrl(value)) {
						outObject["url"] = value;
					}
				}
			} else {
				outObject[newKey] = null;
			}
		}
		return outObject;
	}

	// type string, possibly a ref-
	if (typeof obj === "string") {
		const refMatch = obj.match(/^ref-(.*)/)
		if (refMatch) {
			return resolveReference(brandSDK, refMatch[1]);
		}
	}

	// any other type - return
	return obj;
}

function resolveReference(obj, id = "", format = null){
	if (isValidUrl("" + id)) {
		return id;
	}
	for (const k in obj) {
		if (obj[k]?.id === id) {
			if (obj[k]?.formats) {
				return obj[k].formats.find((cFormat) => {
					return cFormat.format === format;
				}).src || "";
			} else if (obj[k]?.value) {
				return obj[k].value;
			}
		} else if (typeof obj[k] === "object" && obj[k] !== null) {
			const found = resolveReference(obj[k], id, format)
			if (found) {
				return found;
			}
		}
	}

	return "";
}


/*
	deleteUnpublishedDataFromPath will remove by reference what is found in the path
 */
export function deleteUnpublishedDataFromPath(path, data) {
	for (const key in data) {
		if (key.includes(path)) {
			delete data[key];
		}
	}
}

/*
	addUnpublishedDataFromReset adds by reference whats is in the path add all the original values
 */
export function addUnpublishedDataFromReset(
	path,
	unpublishedData,
	localBrandSchemaObj,
	currentBrandData,
	originalBrandData,
	filteredKey = null
) {
	// logic contradition solution, where theres hidden element that are published but not counted
	const excludedInPublisheCount = [
		"favicon-apple-touch",
		"favicon-32",
		"favicon-16",
		"favicon",
	];
	for (let key in localBrandSchemaObj) {
		let currentValue = currentBrandData[key];
		let actualOriginalValue = originalBrandData[key];
		let finalKey = key;
		if (typeof currentValue === "object" && originalBrandData?.[key]) {
			if (currentBrandData[key]?.en && originalBrandData[key]?.en) {
				currentValue = currentBrandData[key].en;
				actualOriginalValue = originalBrandData[key].en;
				finalKey += ".en";
			} else {
				let objectKey = Object.keys(originalBrandData[key])[0];
				currentValue = currentBrandData[key][objectKey];
				actualOriginalValue = originalBrandData[key][objectKey];
				finalKey += "." + objectKey;
			}
		}

		if (actualOriginalValue != null) {
			if (filteredKey) {
				if (key.includes(filteredKey)) {
					if (
						currentValue !== actualOriginalValue &&
						!excludedInPublisheCount.includes(key)
					) {
						unpublishedData[path + "." + finalKey] = {
							value: actualOriginalValue,
							valid: "valid",
						};
					}
					localBrandSchemaObj[key] = originalBrandData[key];
				}
			} else {
				if (currentValue !== actualOriginalValue) {
					unpublishedData[path + "." + finalKey] = {
						value: actualOriginalValue,
						valid: "valid",
					};
				}
				localBrandSchemaObj[key] = originalBrandData[key];
			}
		}
	}
}

export function resizeImgData(canvas, file, width, height = null) {
	let ctx = canvas.getContext("2d");
	let nHeight = height ? height : width;
	ctx.drawImage(file, 0, 0);
	canvas.width = width;
	canvas.height = nHeight;
	ctx.drawImage(file, 0, 0, width, nHeight);

	return canvas.toDataURL("image/png");
}

export function getCurrentBrandFromState(state) {
	return isPartner() ? state.brand : state.userBrand;
}

export function getBestImageFormat(imgFormatsRef) {
	if (isNaN(imgFormatsRef?.length)) {
		return false;
	}

	let fileTypeOrder = ["svg", "png", "jpg"];
	let imgFormats = [...imgFormatsRef];
	let foundFormat = [];
	for (const fileType of fileTypeOrder) {
		imgFormats.forEach((imgFormat, index) => {
			if (imgFormat.format.toLowerCase() === fileType) {
				foundFormat.push(imgFormat);
				imgFormats.splice(index, 1);
			}
		});
	}

	return foundFormat?.length > 0 ? foundFormat[0] : imgFormats[0];
}

export function getSDKImgObj(id) {
	let userSDK = CakeStore.getState().userBrandSDK;
	return userSDK?.logos?.find((logo) => logo.id === id);
}

export function getSDKImgObjFormat(formats = null, type = null) {
	if (type) {
		return formats?.find((format) => {
			return format?.format?.toLowerCase() === type?.toLowerCase();
		});
	}
	return getBestImageFormat(formats);
}


export function getBrandDialogIntro(
	brandKey = null,
	SDKLinkOption= {
		subPath : "", toConnect : false, redirectLink : null, localRedirect : null
	},
	history = null
){
	const resellerName = CakeStore.getState().brand?.name;
	let brandRepoStatus = checkBrandRepo(brandKey);
	let title =I18n.t("app-brand-brand-repo-intro-title");
	let content = <>
		<Translate
			value={"app-brand-brand-repo-intro-desc"}
			resellerName={resellerName}
		/>
		{brandKey &&
			<>
				<br/><br/>
				<Translate
					value={`app-brand-brand-repo-intro-desc-${brandKey}`}
					resellerName={resellerName}
				/>
			</>
		}
	</>;
	let primaryBtnText = I18n.t("app-brand-brand-repo-intro-B");
	if(brandRepoStatus.hasBrandRepo && !brandRepoStatus.hasMinMapping){
		title = <Translate value={`app-brand-brand-repo-intro-title-${brandKey}`}/>;
		content = <Translate
			value={`app-brand-brand-repo-intro-desc-${brandKey}`}
			resellerName={resellerName}
		/>;
		primaryBtnText = <Translate value={`app-brand-brand-repo-intro-B-${brandKey}`}/>;
	}

	const redTo = brandRepoStatus.hasBrandRepo ? "Manager" : "Repo";
	let contextClick = `Brand ${redTo} Redirection Init Confirmed`;
	let contextCancelClick = `Brand ${redTo} Redirection Init Cancelled`;
	const link = SDKLinkOption.localRedirect ? SDKLinkOption.localRedirect : getSDKLink(SDKLinkOption.subPath, SDKLinkOption.toConnect, SDKLinkOption.redirectLink);

	return {
		title:title,
		content:content,
		primaryBtnText:primaryBtnText,
		primaryBtnOnClick:() => {

			setBackToFlow(window.location.hash.replace("#",""),true);

			trackSegmentEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
				context: contextClick,
				redirection: link,
			});
			if(brandRepoStatus.hasBrandRepo && history){
				history.push(link);
			} else {
				window.location = link;
			}
			DialogHandler.hide();
		},
		secondaryBtnText: <Translate value="app-general-cancel" />,
		secondaryBtnOnClick: () => {
			trackSegmentEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
				context: contextCancelClick,
				redirection: link,
			});
			DialogHandler.hide();
		},
	};
}

